export default "__VITE_ASSET__v1KNtCeC__"